import axios from '@/jslib/axios'

export const getGiftList = params => {
  return axios({
    method: 'get',
    url: '/admin/gift/card/list',
    params
  })
}
